module.exports = __webpack_public_path__ + "img/normal_multiplier_4.a71969c6.png";